const theme = {
  config: {
    useColorSchemeMediaQuery: "system",
    useCustomProperties: true,
    initialColorMode: "system",
  },
  colors: {
    text: "#1f2a37",
    background: "#f7fafc",
    surface: "#ffffff",
    muted: "#52606d",
    border: "#d9e2ec",
    primary: "#228be6",
    primaryHover: "#1c7ed6",
    success: "#2fbf71",
    danger: "#ff6b6b",
    inverseText: "#ffffff",
    highlight: "#1c7ed6",
    modes: {
      dark: {
        text: "#e6edf3",
        background: "#0f1720",
        surface: "#151d28",
        muted: "#a9b4c0",
        border: "#2a3645",
        primary: "#228be6",
        primaryHover: "#1c7ed6",
        success: "#2fbf71",
        danger: "#ff6b6b",
        inverseText: "#0f1720",
        highlight: "#6cb8ff",
      },
    },
  },
};

export default theme;
